export class AppConfig {
  // Joe
  // public static API_ENDPOINT = 'https://192.168.5.235:3006/api';

  //    public static API_ENDPOINT = 'https://api.eventorg.co/api';

  // public static API_ENDPOINT = 'http://eventorgapi.cabotprojects.com/api';
  //  public static API_ENDPOINT = 'http://eventorglivestreamapi.cabotprojects.com/api';

  // public static API_ENDPOINT = 'https://eventorgapiserverless.cabotprojects.com/api';

  // public static API_ENDPOINT = "https://eventorgapi.cabotprojects.com";

  // public static API_ENDPOINT = "https://iaoms-api-dev.cabotprojects.com/api";
  public static API_ENDPOINT = "https://iaoms-api-prod.cabotprojects.com/api";

  // public static API_ENDPOINT = 'http://localhost:3006/api';

  public static bsConfig = {
    backdrop: true,
    ignoreBackdropClick: false,
  };

  // public static PhoneRegex = /(?:\+)(?:)(?:9)(?:)(?:1)(?:)[0-9]/;

  public static PhoneRegex = /[0-9]/;

  // live
  public static AccessCode = "AVIO84GD47AJ02OIJA";
  public static ActionLink =
    "https://secure.ccavenue.com/transaction/transaction.do?command=initiateTransaction";
  // public static s3IconsUrl ="https://d11n0xe80534si.cloudfront.net/icons/";
  public static s3IconsUrl = "https://d3og0rqnoe5eci.cloudfront.net/icons/";

  // staging
  // public static AccessCode = "AVUR82FL38BN81RUNB";
  // public static ActionLink = "https://test.ccavenue.com/transaction/transaction.do?command=initiateTransaction";
  // public static s3IconsUrl = "https://d3og0rqnoe5eci.cloudfront.net/icons/";

  public static EmailRegex =
    /(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
  public static UrlRegex =
    /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
  public static FacebookRegex =
    /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm;

  public static onLogin = "/login";
  public static editEvent = "/editEvent";
  public static createParticipant = "/createParticipant";
  public static getParticipantList = "/getParticipantList";
  public static getOneParticipant = "/getOneParticipant";
  public static editParticipant = "/editParticipant";
  public static deleteParticipant = "/deleteParticipant";
  public static contactTypeList = "/contactTypeList";
  public static getSpeakerList = "/getSpeakerList";
  public static addProgram = "/addProgram";
  public static getAllProgramList = "/getAllProgramList";
  public static getOneProgram = "/getOneProgram";
  public static editProgram = "/editProgram";
  public static deleteProgram = "/deleteProgram";
  public static createContact = "/createContact";
  public static editContact = "/editContact";
  public static getContactList = "/getContactList";
  public static deleteContact = "/deleteContact";
  public static getOneContact = "/getOneContact";
  // public static getDefaultModules = "/getModules";
  // public static getModules = "/getDefaultModules";
  public static getModules = "/getModules";
  public static getDefaultModules = "/getDefaultModules";

  public static createEventNews = "/createEventNews";
  public static editEventNews = "/editEventNews";
  public static getOneEventNews = "/getOneEventNews";
  public static getEventNewsList = "/getEventNewsList";
  public static deleteEventNews = "/deleteEventNews";
  public static getQuestionAnswerList = "/getQuestionAnswerList";
  public static deleteFeedback = "/deleteFeedback";
  public static fileUpload = "/upload_images";
  public static signUp = "/signUp";
  public static googleCustomerSignup = "/googleCustomerSignup";
  public static getEventById = "/getEventById";
  public static updateColor = "/updateEventTheme";
  public static editModule = "/editModule";
  public static allUpload = "/upload_files";
  public static createMaterial = "/createMaterial";
  public static editMaterial = "/editMaterial";
  public static getMaterialList = "/getMaterialList";
  public static deleteMaterial = "/deleteMaterial";
  public static getOneMaterial = "/getOneMaterial";
  public static socialwallList = "/socialwallList";
  public static deleteSocial = "/deleteSocialwall";
  public static getAllEvent = "/getAllEvent";
  public static getAllUserType = "/getAllUserType";
  public static publish = "/createPublishEvent";
  public static deleteAllEventNews = "/deleteAllEventNews";
  public static deleteAllEventProgram = "/deleteAllEventProgram";
  public static deleteAllMaterial = "/deleteAllMaterial";
  public static deleteAllSpeaker = "/deleteAllSpeaker";
  public static deleteAllParticipant = "/deleteAllParticipant";
  public static forgotPassword = "/forgotPassword";
  public static getDashboardData = "/getDashboardData";
  public static resetPassword = "/resetPassword";
  public static deleteAllContact = "/deleteAllContact";
  public static deleteSpeaker = "/deleteSpeaker";
  public static getOneSpeaker = "/getOneSpeaker";
  public static editSpeaker = "/editSpeaker";
  public static createSpeaker = "/createSpeaker";
  public static addEvent = "/addEvent";
  public static createSocialwall = "/createSocialwall";
  public static userAuthentication = "/userAuthentication";
  public static createSponsor = "/createSponsor";
  public static editSponsor = "/editSponsor";
  public static deleteSponsor = "/deleteAllSponsor";
  public static getOneSponsor = "/getOneSponsor";
  public static getSponsorList = "/getSponsorList";
  public static createTwitterTags = "/createTwitterTags";
  public static getTwitterTags = "/getTwitterTags";
  public static createOrganisation = "/createOrganisation";
  public static getUserOrganisation = "/getUserOrganisation";
  public static deleteEvents = "/deleteEvents";
  public static getAllOrganisation = "/getAllOrganisation";
  public static getAllEventsByOrganisation = "/getAllEventsByOrganisation";
  public static setPremium = "/setPremium";
  public static setFeatured = "/seFeatured";
  public static getWebModule = "/getWebModule";
  public static updateWebModule = "/updateWebModule";
  public static deleteModule = "/deleteModule";
  public static setPayment = "/setPayment";
  public static verifyPaymentResponse = "/verifyPaymentResponse";
  public static speakerOrder = "/speakerOrder";
  public static materialOrder = "/materialOrder";
  public static getSponsorTypes = "/getSponsorTypes";
  public static getStsToken = "/getStsToken";
  public static getAppBasicDetails = "/getAppBasicDetails";
  public static createAppBasicDetails = "/createAppBasicDetails";
  public static addAboutOrganisation = "/addAboutOrganisation";
  public static getAboutOrganisation = "/getAboutOrganisation";
  public static getEmailTemplate = "/getEmailTemplate";
  public static addEmailTemplate = "/addEmailTemplate";
  public static getAppImages = "/getAppImages";
  public static addAppImages = "/addAppImages";
  public static addDeveloperResources = "/addDeveloperResources";
  public static getDeveloperResources = "/getDeveloperResources";
  public static getWhitelabelBuildStatus = "/getWhitelabelBuildStatus";
  public static whiteLabelBuild = "/whiteLabelBuild";
  public static getAllProgramParticipant = "/getAllProgramParticipant";
  public static listQuestions = "/listQuestions";
  public static adminDeleteQuestion = "/adminDeleteQuestion";
  public static ProgramParticipantCSVdownload =
    "/ProgramParticipantCSVdownload";
}



// WEBPACK FOOTER //
// C:/Users/neenu.korula/AA/eventorg-web/src/app/config/app.config.ts